class NotificationManager {
  constructor() {
    this.listeners = new Set();
  }

  subscribe(callback) {
    this.listeners.add(callback);
    return () => this.listeners.delete(callback);
  }

  show(message, type = 'info', duration = 4000) {
    const notification = {
      id: Date.now() + Math.random(),
      message,
      type,
      duration,
    };

    console.log('Showing notification:', notification); // Debug log
    this.listeners.forEach(callback => callback(notification));
  }

  success(message, duration) {
    this.show(message, 'success', duration);
  }

  error(message, duration) {
    this.show(message, 'error', duration);
  }

  info(message, duration) {
    this.show(message, 'info', duration);
  }

  warning(message, duration) {
    this.show(message, 'warning', duration);
  }
}

// Create singleton instance
export const notificationManager = new NotificationManager();
